<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <modal @close="$emit('close')">
        <template v-slot:header>
            <div class="container" style="width: 960px; padding-left: 0px;">
                <div class="row" style="margin-left: 0!important;">
                    <h5 style="padding-left: 0;">Downtime Summary</h5>
                </div>
            </div>
        </template>
        <template v-slot:content>
            <div class="container" style="width: 960px; ">
                <div class="row" style="margin-left: 0!important; margin-bottom: 10px; cursor: pointer">
                    <downtime-summary-filter class="col-sm-3" type="uncommented" :count="uncommentedDowntimeCount" :totalHour="uncommentedDowntimeDurationInSeconds" @downtimeFilterSelected="filterChanged" :currentlySelected="currentlySelected"></downtime-summary-filter>
                    <downtime-summary-filter class="col-sm-3" type="planned" :count="plannedDowntimeCount" :totalHour="plannedDowntimeDurationInSeconds" @downtimeFilterSelected="filterChanged" :currentlySelected="currentlySelected"></downtime-summary-filter>
                    <downtime-summary-filter class="col-sm-3" type="unplanned" :count="unplannedDowntimeCount" :totalHour="unplannedDowntimeDurationInSeconds" @downtimeFilterSelected="filterChanged" :currentlySelected="currentlySelected"></downtime-summary-filter>
                    <downtime-summary-filter class="col-sm-3" type="all" :count="allDowntimeCount" :totalHour="allDowntimeDurationInSeconds" @downtimeFilterSelected="filterChanged" :currentlySelected="currentlySelected"></downtime-summary-filter>
                </div>
                <div>
                    <ul class="list-group">
                        <downtime-summary-list-item
                            v-for="downtime in downtimeSummary"
                            :key="downtime.id"
                            :downtime="downtime"
                            :reasonGroups="reasonGroups"
                            :allReasons="allReasons"
                            @downtimeReasonAssigned="reasonAssigned"
                            v-if="!downtime.filteredOut">
                        </downtime-summary-list-item>
                    </ul>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="pb-0" style="padding-right: 15px;">
                <button class="btn btn-outline-danger" @click.prevent="$emit('close')">Close</button>
                <button class="btn btn-success ms-3" @click="assignDowntimeReason();" >Assign</button>
            </div>
        </template>

    </modal>
</template>

<script>
    import Modal from "../../Modal";
    import DowntimeSummaryService from "../../../services/DowntimeSummaryService";
    import DowntimeReasonService from "../../../services/DowntimeReasons";
    import ToastrService from "../../../services/ToastrService";
    import DowntimeSummaryFilter from "./DowntimeSummaryFilter";
    import DowntimeSummaryListItem from "./DowntimeSummaryListItem";

    export default {
        name: "DowntimeSummaryModal",
        data: () => {
            return {
                downtimeSummary: [],
                reasonGroups: [],
                allReasons: [],
                isAllSelected: true,
                isUncommentedSelected: false,
                isPlannedSelected: false,
                isUnplannedSelected: false,
                allDowntimeCount: 0,
                uncommentedDowntimeCount: 0,
                plannedDowntimeCount: 0,
                unplannedDowntimeCount: 0,
                allDowntimeDurationInSeconds: 0,
                uncommentedDowntimeDurationInSeconds: 0,
                plannedDowntimeDurationInSeconds: 0,
                unplannedDowntimeDurationInSeconds: 0,
                downtimeId: null,
                downtimeReasonId: null,
                eventData: null,
                currentlySelected: '',
            }
        },
        components: {
            modal: Modal,
            DowntimeSummaryFilter,
            DowntimeSummaryListItem
        },
        methods:{
            reasonAssigned(eventData){
                this.eventData = eventData;
                this.downtimeId = eventData.downtime.id;
                this.downtimeReasonId = eventData.downtimeReason ? eventData.downtimeReason.id : null;
            },


            assignDowntimeReason(){
                DowntimeReasonService.assignDowntime({
                    downtimeId: this.downtimeId,
                    downtimeReasonId: this.downtimeReasonId,
                },()=>{
                    ToastrService.showSuccessToast('Downtime reason successfully assigned.');
                    this.$emit('assigned');
                    for(let i =0; i< this.downtimeSummary.length;i++){
                        if(this.downtimeSummary[i].id === this.eventData.downtime.id){
                            this.downtimeSummary[i].reason = this.eventData.downtimeReason;
                            break;
                        }
                    }
                    this.processDowntimeSummaryData();
                    // window.location.reload();
                });
            },
            removeDowntimeReason() {
                DowntimeReasonService.removeDowntime({
                    downtimeId: this.downtimeId,
                }, () => {
                    ToastrService.showSuccessToast('Downtime reason removed successfully.');
                    this.$emit('assigned');
                });
            },
            processDowntimeSummaryData(){
                this.allDowntimeCount = 0;
                this.uncommentedDowntimeCount=0;
                this.plannedDowntimeCount=0;
                this.unplannedDowntimeCount=0;
                this.allDowntimeDurationInSeconds=0;
                this.uncommentedDowntimeDurationInSeconds=0;
                this.plannedDowntimeDurationInSeconds=0;
                this.unplannedDowntimeDurationInSeconds=0;

                for(let i =0; i < this.downtimeSummary.length; i++){
                    if(!this.downtimeSummary[i].reason) {
                        this.$set(this.downtimeSummary[i], 'selectedReasonGroupName', "Please Select");
                        this.$set(this.downtimeSummary[i], 'selectedReasonName', "Please Select");
                        this.uncommentedDowntimeCount++;
                        this.uncommentedDowntimeDurationInSeconds += this.downtimeSummary[i].duration;
                    } else {
                        this.$set(this.downtimeSummary[i], 'selectedReasonGroupName', this.downtimeSummary[i].reason.reason_group.name);
                        this.$set(this.downtimeSummary[i], 'selectedReasonName', this.downtimeSummary[i].reason.name);
                        if(this.downtimeSummary[i].reason.type === 'planned'){
                            this.plannedDowntimeCount++;
                            this.plannedDowntimeDurationInSeconds += this.downtimeSummary[i].duration;
                        } else if(this.downtimeSummary[i].reason.type === 'unplanned'){
                            this.unplannedDowntimeCount++;
                            this.unplannedDowntimeDurationInSeconds += this.downtimeSummary[i].duration;
                        } else if(this.downtimeSummary[i].reason.type === 'uncommented'){
                            this.uncommentedDowntimeCount++;
                            this.uncommentedDowntimeDurationInSeconds += this.downtimeSummary[i].duration;
                        }
                    }
                }
                this.allDowntimeCount = parseInt(this.uncommentedDowntimeCount)+parseInt(this.plannedDowntimeCount)+parseInt(this.unplannedDowntimeCount);
                this.allDowntimeDurationInSeconds = parseInt(this.uncommentedDowntimeDurationInSeconds)+parseInt(this.plannedDowntimeDurationInSeconds)+parseInt(this.unplannedDowntimeDurationInSeconds);
            },
            filterChanged(event) {
                this.currentlySelected = event.type;
                if(event.type==='all') {
                    this.isAllSelected = true;
                    this.isUncommentedSelected = false;
                    this.isPlannedSelected = false;
                    this.isUnplannedSelected = false;
                    this.updateDowntimeLists();
                }
                if(event.type==='uncommented') {
                    this.isUncommentedSelected = true;
                    this.isAllSelected = false;
                    this.isPlannedSelected = false;
                    this.isUnplannedSelected = false;
                    this.updateDowntimeLists();
                }
                if(event.type==='planned') {
                    this.isPlannedSelected = true;
                    this.isAllSelected = false;
                    this.isUncommentedSelected = false;
                    this.isUnplannedSelected = false;
                    this.updateDowntimeLists();
                }
                if(event.type==='unplanned') {
                    this.isUnplannedSelected = true;
                    this.isPlannedSelected = false;
                    this.isAllSelected = false;
                    this.isUncommentedSelected = false;
                    this.updateDowntimeLists();
                }
            },

            updateDowntimeLists() {
                for(let i =0; i<this.downtimeSummary.length;i++) {
                    this.$set(this.downtimeSummary[i], 'filteredOut', true);
                    if(this.isAllSelected) {
                        this.$set(this.downtimeSummary[i], 'filteredOut', !this.isAllSelected);
                        continue;
                    }
                    if(this.isUncommentedSelected && !this.downtimeSummary[i].reason) {
                        this.$set(this.downtimeSummary[i], 'filteredOut', !this.isUncommentedSelected);
                        continue;
                    }
                    if(this.downtimeSummary[i].reason) {
                        if(this.downtimeSummary[i].reason.type==='unplanned'){
                            this.$set(this.downtimeSummary[i], 'filteredOut', !this.isUnplannedSelected);
                        } else if(this.downtimeSummary[i].reason.type==='planned'){
                            this.$set(this.downtimeSummary[i], 'filteredOut', !this.isPlannedSelected);
                        }
                    }
                }
            }
        },
        mounted: function () {
            const vm = this;
            vm.currentlySelected = 'all';
            DowntimeReasonService.fetchAllGroups(function (resData) {
                vm.reasonGroups = resData;
            });
            DowntimeReasonService.fetchAll(null,function (resData) {
                vm.allReasons = resData['downtime_reason_list'];
            });
            DowntimeSummaryService.getDowntimeSummary(
                moment(vm.date).format('YYYY-MM-DD'),
                vm.stationId,
                vm.stationShiftId,
                function (resData) {
                    vm.downtimeSummary = resData;
                    vm.processDowntimeSummaryData();
                    this.$emit('assigned');
                }
            )
        },
        props: {
            stationId : Number,
            stationShiftId : Number,
            date: Date
        },
    }
</script>

<style scoped>
.toast-title{font-weight:700}.toast-message{-ms-word-wrap:break-word;word-wrap:break-word}.toast-message a,.toast-message label{color:#FFF}.toast-message a:hover{color:#CCC;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#FFF;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80);line-height:1}.toast-close-button:focus,.toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}.rtl .toast-close-button{left:-.3em;float:left;right:.3em}button.toast-close-button{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.toast-top-center{top:0;right:0;width:100%}.toast-bottom-center{bottom:0;right:0;width:100%}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-left{bottom:12px;left:12px}#toast-container{position:fixed;z-index:999999;pointer-events:none}#toast-container *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}#toast-container>div{position:relative;pointer-events:auto;overflow:hidden;margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;background-position:15px center;background-repeat:no-repeat;-moz-box-shadow:0 0 12px #999;-webkit-box-shadow:0 0 12px #999;box-shadow:0 0 12px #999;color:#FFF;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}#toast-container>div.rtl{direction:rtl;padding:15px 50px 15px 15px;background-position:right 15px center}#toast-container>div:hover{-moz-box-shadow:0 0 12px #000;-webkit-box-shadow:0 0 12px #000;box-shadow:0 0 12px #000;opacity:1;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);filter:alpha(opacity=100);cursor:pointer}#toast-container>.toast-info{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important}#toast-container>.toast-error{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important}#toast-container>.toast-success{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important}#toast-container>.toast-warning{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important}#toast-container.toast-bottom-center>div,#toast-container.toast-top-center>div{width:300px;margin-left:auto;margin-right:auto}#toast-container.toast-bottom-full-width>div,#toast-container.toast-top-full-width>div{width:96%;margin-left:auto;margin-right:auto}.toast{background-color:#030303}.toast-success{background-color:#51A351}.toast-error{background-color:#BD362F}.toast-info{background-color:#2F96B4}.toast-warning{background-color:#F89406}.toast-progress{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}@media all and (max-width:240px){#toast-container>div{padding:8px 8px 8px 50px;width:11em}#toast-container>div.rtl{padding:8px 50px 8px 8px}#toast-container .toast-close-button{right:-.2em;top:-.2em}#toast-container .rtl .toast-close-button{left:-.2em;right:.2em}}@media all and (min-width:241px) and (max-width:480px){#toast-container>div{padding:8px 8px 8px 50px;width:18em}#toast-container>div.rtl{padding:8px 50px 8px 8px}#toast-container .toast-close-button{right:-.2em;top:-.2em}#toast-container .rtl .toast-close-button{left:-.2em;right:.2em}}@media all and (min-width:481px) and (max-width:768px){#toast-container>div{padding:15px 15px 15px 50px;width:25em}#toast-container>div.rtl{padding:15px 50px 15px 15px}}
</style>
